export const VERSION = '4.3.3-gogreen';
export const GIT_HASH = 'aa0413813335183db072a089ae1f3f5267e80978';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
